






import Vue, { PropType } from "vue";

import _ from "lodash";

import { WidgetData } from "@/model/data/dashboard/WidgetData";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";

export default Vue.extend({
    props: {
        data: Object as PropType<WidgetData>,
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    id: "vuechart-heatgrid",
                },
                xaxis: {
                    categories: this.data.labels,
                    type: "category",
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#000"],
                    },
                },
                plotOptions: {
                    heatmap: {
                        distributed: false,
                        enableShades: true,
                    },
                },
            };
        },
        chartSeries() {
            return _.map(this.data.series, (serie) => {
                return {
                    name: serie.name,
                    data: serie.values,
                };
            });
        },
    },
});
